<script>
import Axios from "axios"
export default {
  install(Vue, options) {
    if (!options) {
      options = {};
    }
    if (!options.cvrRestApiAddress) {
      options.cvrRestApiAddress = "";
    }
    if (!options.authorization) {
      options.authorization = "Authorization";
    }
    if (!options.authorizationScheme) {
      options.authorizationScheme = "Access";
    }
    var CvrRestApi = function (cvrRestApiAddress, authorization, authorizationScheme) {
      var accessToken = null;
      var renewing = false;
      var queue = [];

      var completeQueued = function () {
        var queued = queue.splice(0, queue.length);
        for (var i = 0; i < queued.length; i++) {
          queued[i]();
        }
      };

      var renew = function (done) {
        if (renewing) {
          queue.push(done);
        } else {
          renewing = true;
          Axios.post(cvrRestApiAddress + "/access-tokens")
              .then(function (response) {
                accessToken = response.data;
                done();
                completeQueued();
              })
              .catch(function (err) {
                console.log(err);
              })
              .then(function () {
                renewing = false;
              })
        }
      };

      var execute = function (options) {
        if (!options.headers) {
          options.headers = {};
        }
        options.headers[authorization] = authorizationScheme + " " + accessToken;
        if (!options.success) {
          options.success = function () {
          }
        }
        if (!options.error) {
          options.error = function () {
          }
        }
        if (!options.complete) {
          options.complete = function () {
          }
        }
        if (options.url && options.url.startsWith("/")) {
          options.url = cvrRestApiAddress + options.url
        }
        Axios(options).then(options.success).catch(options.error).then(options.complete)
      };

      var ajax = function (options) {
        var job = function () {
          var renewed = false;
          var existingError = options.error;
          options.error = function (error) {
            if (error.response.status == 401 && !renewed) {
              renewed = true;
              renew(function () {
                execute(options);
              });
            }
            if (typeof existingError == "function") {
              existingError(error);
            }
          };
          execute(options);
        };
        if (accessToken == null) {
          renew(job);
        } else {
          job();
        }
      };

      return {
        ajax: ajax
      }
    }
    Vue.$cvrRestApi = new CvrRestApi(options.cvrRestApiAddress, options.authorization, options.authorizationScheme)
  }
}
</script>